<template>
    <header class="header">
        <div class="header_info">
            <div class="div_logo">
                <img class="img_logo" v-if="logo.length > 1" :src="logo" style="width:80px;height: 80px;" alt=""/>
                <span class="name_logo">{{ name }}</span>
            </div>
            <div class="div_nav">
                <router-link v-if="approval_num > 0" :class="activeIndex===2?'selected':'no_selected'" to="/home_page">个人中心</router-link>
                <router-link v-if="approval_num > 0" :class="activeIndex===5?'selected':'no_selected'" to="#" @click="sign_out">退出登录
                </router-link>
            </div>
        </div>
    </header>
</template>

<script>
import logo from '@/assets/logo.png';

export default {
    name: 'Header',
    props: {
        chose_index: String
    },
    data() {
        return {
            activeIndex: '1',
            logo: logo,
            name: '茗硕',
            approval_num: 0,
        }
    },
    created() {
        let agent = JSON.parse(localStorage.getItem('user_info'))
        console.log(agent)
        if (agent !== null && agent.id !== undefined && agent.id !== null && agent.logo !== undefined && parseInt(agent.show_logo) === 1) {
            if (agent.logo.length > 1) {
                this.logo = agent.logo
            }
            if (agent.name !== undefined && agent.name !== null && agent.name.length > 1) {
                this.name = agent.name
            }
        }
        this.activeIndex = parseInt(this.chose_index)
        if(this.activeIndex === 0){
            this.name = '登录代理商系统后台'
            this.logo = ''
        }
        this.approval_num = parseInt(localStorage.getItem('approval_num'))
    },
    methods: {
        sign_out() {
            localStorage.clear()
            this.$router.push('/')
        }
    },
}
</script>

<style scoped>
* {
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}

.selected {
    font-weight: bold;
    color: #C23B1E
}

.no_selected {
    font-weight: bold;
}

.header {
    width: 100%;
    height: 100px;
    text-align: center;
    margin: 0 auto;
    box-shadow: 0px 5px 5px #F8F8F8;
}

.header_info {
    margin: 0 auto;
    width: 64%;
    display: flex;
    display: -webkit-flex;
}

.div_logo {
    justify-content: flex-start;
    display: flex;
    display: -webkit-flex;
    align-items: center;
}

.img_logo {
    height: 100px;
}

.name_logo {
    height: 100px;
    line-height: 100px;
    margin-left: 20px;
    font-weight: bold;
    font-size: 30px;
}

.div_nav {
    flex: 1;
    justify-content: flex-end;
    display: flex;
    display: -webkit-flex;
    align-items: center;
}

.div_nav a {
    margin-left: 50px;
}

a {
    color: #666666;
    text-decoration: none;
}

a:link {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}

a:focus {
    text-decoration: none;
}

</style>
